import { Pipe, PipeTransform, inject } from '@angular/core';
import { UserGlobalService } from '../services/user-global.service'; // Adjust path as needed

@Pipe({
  name: 'able',
  standalone: true,
  pure: false // Set to false if permissions can change during component lifecycle ../../services/user-global.service
})
export class AblePipe implements PipeTransform {
  private userService = inject(UserGlobalService);

  transform(action: string, resource: string): boolean {
    // Implement your permission checking logic here
    const user :any= this.userService.isSuperAdmin();
    if (!user) return false;
    
    // Example permission check - adapt this to your needs
    const permissions = user?.permissions || [];
   // ✅ handle both array and single role formats
const roles = user?.roles ? user.roles : user?.userRole?.() || [];
const hasAdminRole =  roles.some((r: any) =>
  ['admin', 'super_admin'].includes(r.role)
);
return permissions.includes(`${action}_${resource}`) || hasAdminRole;
  }
}